import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types as api } from '@mesa-labs/mesa-api';
import { DefaultPaginationDropdownLimits, PaginationDropdownLimit } from '@mesa-labs/mesa-ui/dist/components/Pagination';

const DefaultPaginationDropdownLimit = DefaultPaginationDropdownLimits[DefaultPaginationDropdownLimits.length - 1];

export type InvoiceApprovalsState = {
  approvalReason?: api.ManualApprovalReason;
  page?: number;
  totalPages?: number;
  limit?: PaginationDropdownLimit;
  sortField?: string;
  sortDirection?: api.SortDirection;
};

const initialState: InvoiceApprovalsState = {
  approvalReason: undefined,
  page: 1,
  totalPages: undefined,
  limit: DefaultPaginationDropdownLimit,
  sortField: undefined,
  sortDirection: api.SortDirection.ASCENDING,
};

const invoiceApprovalsSlice = createSlice({
  name: 'invoiceApprovals',
  initialState,
  reducers: {
    updateApprovalReason(state: InvoiceApprovalsState, action: PayloadAction<api.ManualApprovalReason | undefined>) {
      state.approvalReason = action.payload;
    },
    updatePage(state: InvoiceApprovalsState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    updateTotalPages(state: InvoiceApprovalsState, action: PayloadAction<number>) {
      state.totalPages = action.payload;
    },
    updateLimit(state: InvoiceApprovalsState, action: PayloadAction<PaginationDropdownLimit>) {
      state.limit = action.payload;
    },
    updateSortField(state: InvoiceApprovalsState, action: PayloadAction<string>) {
      state.sortField = action.payload;
    },
    updateSortDirection(state: InvoiceApprovalsState, action: PayloadAction<api.SortDirection>) {
      state.sortDirection = action.payload;
    },
  },
});

export const {
  updateApprovalReason,
  updatePage,
  updateTotalPages,
  updateLimit,
  updateSortField,
  updateSortDirection,
} = invoiceApprovalsSlice.actions;
export default invoiceApprovalsSlice.reducer;
